import React, { useEffect, useState } from "react";
import { Upload, Button, message, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import customerBannerService from "../../../services/customerBanner-service";

function CustomerBannerForm({ formModal, setFormModal, recordForm, onSuccess }) {
    const [fileList, setFileList] = useState([]);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (recordForm?.url) {
            setFileList([
                {
                    uid: "-1",
                    name: "banner.png",
                    status: "done",
                    url: recordForm.url,
                },
            ]);
        } else {
            setFileList([]);
        }
    }, [recordForm, formModal]);


    const handleChange = ({ fileList }) => {
        setFileList(fileList);
    };


    const handleSave = async () => {
        if (!recordForm && fileList.length === 0) {
            message.warning("Please upload a banner image (1140 x 254 px)");
            return;
        }

        if (fileList[0]?.originFileObj === undefined && !recordForm) {
            message.error("Invalid image. Please upload correct size (1140 x 254 px).");
            return;
        }

        const formData = new FormData();
        // append ONLY if user selected a new file
        if (fileList[0]?.originFileObj) {
            formData.append("banner", fileList[0].originFileObj);
        }
        setSaving(true);

        let response;

        if (recordForm) {
            formData.append('_method', 'PUT');
            response = await customerBannerService.edit(recordForm.id, formData)
        }

        else {
            response = await customerBannerService.add(formData);
        }

        setSaving(false);

        if (response?.success) {
            message.success(recordForm ? "Banner updated successfully" : "Banner added successfully");
            setFormModal(false);
            setFileList([]);
            onSuccess();
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            message.error("Only image files are allowed!");
            return Upload.LIST_IGNORE;
        }

        const isLt2MB = file.size / 1024 / 1024 < 2;
        if (!isLt2MB) {
            message.error("Image must be smaller than 2MB!");
            return Upload.LIST_IGNORE;
        }

        return new Promise((resolve) => {
            const img = new Image();
            img.src = URL.createObjectURL(file);

            img.onload = () => {
                const width = img.width;
                const height = img.height;

                if (width !== 1140 || height !== 254) {
                    message.error("Image must be exactly 1140 x 254 px");
                    resolve(Upload.LIST_IGNORE); // 🚀 THIS FIXES IT
                } else {
                    resolve(file);
                }
            };
        });
    };



    return (
        <Modal
            open={formModal}
            footer={null}
            onCancel={() => setFormModal(false)}
            width={450}
            centered
            destroyOnClose
        >
            <div className="flex justify-center">
                <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onChange={handleChange}
                    beforeUpload={beforeUpload}
                    accept="image/*"
                    maxCount={1}
                    className="custom-upload"
                >
                    {fileList.length < 1 && (
                        <div>
                            <PlusOutlined />
                            <div style={{ marginTop: 8 }}>Upload <br />
                                <span style={{ fontSize: 12, color: "#888" }}>
                                    Required size: 1140 x 254 px
                                </span>
                            </div>
                        </div>
                    )}
                </Upload>
            </div>

            <div style={{ marginTop: 20, textAlign: "right" }}>
                <Button type="primary" loading={saving} onClick={handleSave}>
                    {recordForm ? "Update Banner" : "Save Banner"}
                </Button>
            </div>
            <style>
                {
                    `
                    .custom-upload .ant-upload-select {
    width: 160px !important;
    height: 150px !important;
}

                    `
                }
            </style>
        </Modal>
    );
}

export default CustomerBannerForm;
